import { AddUsersToPlanUseCase } from "@/application/usecases/AddUsersToPlanUseCase";
import { CreatePartnerUseCase } from "@/application/usecases/CreatePartnerUseCase";
import { ListPartnersUseCase } from "@/application/usecases/ListPartnersUseCase";
import { ShowPartnerUseCase } from "@/application/usecases/ShowPartnerUseCase";
import { ListUserSubscriptionHistoryUseCase } from "@/application/usecases/ListUserSubscriptionHistoryUseCase";
import { PartnerRemoteDataSource } from "@/infrastructure/datasources/implementations/remote/PartnerRemoteDataSource";
import { UserSubscriptionHistoryRemoteDataSource } from "@/infrastructure/datasources/implementations/remote/UserSubscriptionHistoryRemoteDataSource";
import { PartnerRepository } from "@/infrastructure/repositories/PartnerRepository";
import { UserSubscriptionHistoryRepository } from "@/infrastructure/repositories/UserSubscriptionHistoryRepository";
import { NetworkService } from "@/services/NetworkService";
import HttpEventHandler from "@/presentation/adapters/HttpEventHandler";
import router from "@/router";
import AuthTokenProvider from "@/presentation/adapters/AuthTokenProvider";
import PrescriptionsService from "@/services/PrescriptionsService";
import MedicalRecordsService from "@/services/MedicalRecordsService";
import PatientsService from "@/services/PatientsService";
import AIFilesService from "@/services/AIFilesService";
import MedicinesService from "@/services/MedicinesService";
import ContentsService from "@/services/ContentsService";
import UserService from "@/services/UserService";
import CouponsService from "@/services/CouponsService";

const httpEventHandler = new HttpEventHandler(router)
const authTokenProvider = new AuthTokenProvider()
const network = new NetworkService(httpEventHandler, authTokenProvider)
export const services = {
    prescriptionsService: new PrescriptionsService(network),
    medicalRecordsService: new MedicalRecordsService(network),
    patientsService: new PatientsService(network),
    aiFilesService: new AIFilesService(network),
    medicinesService: new MedicinesService(network),
    contentsService: new ContentsService(network),
    userService: new UserService(network),
    couponsService: new CouponsService(network),
}
const dataSources = {
    partnerDataSource: new PartnerRemoteDataSource(network),
    userSubscriptionHistoryDataSource: new UserSubscriptionHistoryRemoteDataSource(network),
}
const repositories = {
    partnerRepository: new PartnerRepository(dataSources.partnerDataSource),
    userSubscriptionHistoryRepository: new UserSubscriptionHistoryRepository(dataSources.userSubscriptionHistoryDataSource),
}

export const useCases = {
    createPartnerUseCase: new CreatePartnerUseCase(repositories.partnerRepository),
    listPartnersUseCase: new ListPartnersUseCase(repositories.partnerRepository),
    showPartnerUseCase: new ShowPartnerUseCase(repositories.partnerRepository),
    addUsersToPlanUseCase: new AddUsersToPlanUseCase(repositories.partnerRepository),
    listUserSubscriptionHistoryUseCase: new ListUserSubscriptionHistoryUseCase(repositories.userSubscriptionHistoryRepository),
}